import { Consumer as C, createContext } from 'react';
import Dependency from '../../core/Dependency';

export const context = createContext({} as Dependency);
export const Provider = context.Provider;
export const Consumer = context.Consumer as C<Dependency>;
